module.exports = __webpack_public_path__ + "static/media/cracking-the-code.45e3e2c8.jpg";